// extracted by mini-css-extract-plugin
export default {"MenuKebabItem":"MenuKebabItem_MenuKebabItem__-q-8n","MenuKebabItem__dropdown":"MenuKebabItem_MenuKebabItem__dropdown__hfwz+"};